import React, {useEffect, useState} from "react";
import Title from "../Comps/Title";
import {handleResponse} from "../Scripts/handle-response";
import Loading from "../Loading/Loading";

const StoryTime = () => {
    const [stories, setStories] = useState([])
    const [storyItems, setStoryItems] = useState([])
    const [storyLoaded, setStoryLoaded] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [page, setPage] = useState(1);
    const [navOpen, setNavOpen] = useState(false);

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    const getStories = () => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json'},
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/stories/getStories`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setStories(result)
                    setLoaded(true)
                    changePage(result[0].id)
                },
                (error) => {console.error(error)}
            )
    }

    const changePage = (id) => {
        setStoryLoaded(false)
        setPage(id)

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify({'story_id': id})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/stories/getStoryItems`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setStoryItems(result)
                    setStoryLoaded(true)
                },
                (error) => {console.error(error)}
            )
    }

    useEffect(() => {
        getStories()
    }, [])

    if (loaded) {
        return (
            <div className="p-3 md:p-20">
                <div className="flex w-full gap-6">
                    <button
                        type="button"
                        className="fixed right-4 top-4 z-40 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-md ring-1 ring-gray-200 md:hidden"
                        onClick={() => setNavOpen(true)}
                        aria-label="Open stories navigation"
                    >
                        Stories
                    </button>

                    {navOpen && (
                        <div className="fixed inset-0 z-50 md:hidden">
                            <button
                                type="button"
                                className="absolute inset-0 bg-black/40"
                                onClick={() => setNavOpen(false)}
                                aria-label="Close stories navigation"
                            />

                            <aside className="absolute inset-y-0 left-0 w-[80%] bg-white p-4 shadow-xl">
                                <nav aria-label="Sidebar" className="flex flex-1 flex-col">
                                    <ul className="flex flex-1 flex-col gap-y-7">
                                        <li>
                                            <div className="mt-2 flex items-center justify-between">
                                                <h3 className="text-2xl font-semibold text-gray-900">
                                                    Stories
                                                </h3>

                                                <button
                                                    type="button"
                                                    className="rounded-md px-2 py-1 text-sm font-semibold text-gray-500 hover:bg-gray-100 hover:text-gray-900"
                                                    onClick={() => setNavOpen(false)}
                                                    aria-label="Close stories navigation"
                                                >
                                                    ✕
                                                </button>
                                            </div>

                                            <ul className="-mx-2 mt-2 space-y-1">
                                                {stories.map((item) => (
                                                    <li key={item.name}>
                                                        <button
                                                            className={classNames(
                                                                item.page === page
                                                                    ? 'bg-gray-100 text-indigo-600'
                                                                    : 'text-gray-700 hover:bg-gray-100 hover:text-indigo-600',
                                                                'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold w-[90%]',
                                                            )}
                                                            onClick={() => {
                                                                changePage(item.id);
                                                                setNavOpen(false);
                                                            }}
                                                        >
                                            <span
                                                className={classNames(
                                                    item.page === page
                                                        ? 'border-indigo-600 text-indigo-600'
                                                        : 'border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600',
                                                    'flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium',
                                                )}
                                            >
                                                {item.initial}
                                            </span>

                                                            <span className="truncate">{item.name}</span>
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </aside>
                        </div>
                    )}

                    <aside className="sticky top-4 h-[calc(100vh-2rem)] w-64 shrink-0 self-start hidden md:block">
                        <nav aria-label="Sidebar" className="flex flex-1 flex-col">
                            <ul className="flex flex-1 flex-col gap-y-7">
                                <li>
                                    <h3 className="text-2xl font-semibold text-gray-900 mt-2">
                                        Stories
                                    </h3>

                                    <ul className="-mx-2 mt-2 space-y-1">
                                        {stories.map((item) => (<li key={item.name}>
                                            <button
                                                className={classNames(item.page === page ? 'bg-gray-100 text-indigo-600' : 'text-gray-700 hover:bg-gray-100 hover:text-indigo-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold w-[90%]',)}
                                                onClick={() => changePage(item.id)}
                                            >
                                    <span
                                        className={classNames(item.page === page ? 'border-indigo-600 text-indigo-600' : 'border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600', 'flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium',)}
                                    >
                                        {item.initial}
                                    </span>

                                                <span className="truncate">{item.name}</span>
                                            </button>
                                        </li>))}
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </aside>

                    <main className="min-w-0 flex-1">
                        <Title title={stories.find((story) => story.id === page).name} desc={stories.find((story) => story.id === page).desc}/>
                        <ul className="space-y-6">
                            {storyLoaded ? storyItems.map((story, index) => (<li key={index} className="relative flex gap-x-4">
                                    <div className="flex flex-col gap-6 rounded-2xl bg-white/90 p-6 shadow-lg md:flex-row">
                                        <div className="flex-1">
                                            <h2 className="text-2xl font-bold text-gray-900">
                                                {story.title}
                                            </h2>

                                            <p className="mt-1 text-sm font-semibold text-gray-500">
                                                {story.version}
                                            </p>

                                            <div className="mt-4 space-y-4 text-gray-700">
                                                {JSON.parse(story.changes).map((change, index) => (
                                                    <p key={index}>
                                                        {change}
                                                    </p>
                                                ))}
                                            </div>
                                        </div>

                                        {story.image && (
                                            <div className="md:w-64 md:flex-shrink-0">
                                                <div className="overflow-hidden rounded-xl border border-gray-200 bg-gray-100 shadow-sm">
                                                    <img
                                                        src={story.image}
                                                        alt={story.title}
                                                        className="h-56 w-full object-cover md:h-full"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </li>))
                                : (<Loading />)}
                        </ul>
                        {page === 1 && (
                            <>

                            </>
                        )}
                        {/*desc={"The gang hits the seas while trying to escape The2kGamer"}*/}
                    </main>
                </div>
            </div>
        );
    }  else {
        return <Loading />
    }
};

export default StoryTime;